import { environment } from "../../environments/environment";

export class AppConfig {
  public readonly apiURL = environment.apiUrl;
  public readonly paymentURL = environment.paymentApiURL;
  public readonly authkey = "RwBsAG8AYgBhAGwAQQB6AEMAbwBuAGYARABlAHYA";
  public readonly GetEventYear = new Date().getFullYear().toString();
  public readonly getEventData = "Event/GetEventByYear?eventYear={0}";
  public readonly GetEventId = this.getEventId();
  public readonly GetAllVolunteer = "Volunteer?eventId={0}&isAdmin={1}";
  public readonly PostVolunteer = "Volunteer";
  public readonly UpdateVolunteer = "Volunteer";
  public readonly PostImageVolunteer = "Volunteer/UploadVolunteerImage";
  public readonly UserLogin = "User/UserLogin?email={0}&password={1}";
  public readonly GetVolunteerByid = "Volunteer/{0}?eventId={1}";
  public readonly StatusChangeVolunteer =
    "Volunteer/StatusChangeVolunteer?id={0}&status={1}";
  public readonly StatusChangeCommunity =
    "Community/StatusChangeCommunity?id={0}&status={1}";
  public readonly uploadCommunityImage = "Community/UploadCommunityImage";
  public readonly createCommunity = "Community/CreateCommunity";
  public readonly getCommunity = "Community?isAdmin={0}&eventId={1}";
  public readonly updateCommunity = "Community";
  public readonly GetSessionize = "Sessionize/GetSessionize?eventId={0}";
  public readonly CreateSessionize = "Sessionize/AddSessionize";
  public readonly addSponsors = "Sponsor";
  public readonly uploadSponsorImage = "Sponsor/UploadSponsorImage";
  public readonly getSponser = "Sponsor?eventId={0}&isAdmin={1}";
  public readonly StatusChangeSponsers =
    "Sponsor/StatusChangeSponsor?id={0}&status={1}";
  public readonly GetSpeakersList = "Speaker?eventId={0}&isAdmin={1}";
  public readonly StatusChangeSpeakers =
    "Speaker/StatusChangeSpeakers?id={0}&status={1}";
  public readonly StatusChangeWorkshop =
    "Workshop/StatusChangeWorkshop?id={0}&status={1}";

  public readonly SyncSessionize =
    "Sessionize/SyncSessionize?eventId={0}&SyncType={1}";
  public readonly GetSponsorIdid = "Sponsor/{0}?eventId={1}";
  public readonly sponsorUpdate = "Sponsor";
  //WorkShop
  public readonly WokshopList = "Workshop/GetAdminAllWorkshops?eventId={0}";
  public readonly individualWorkShopList =
    "Workshop/GetAdminWorkshopByIdAsync?id={0}&eventId={1}";
  public readonly InsertWorkShop = "Workshop/CreateWorkshop";

  //Live Session

  public readonly getLivesession = "Live/GetAllLiveSessions?eventId={0}";
  //live notifications
  public readonly NotificationFunctionUrl =
    "https://azconf-notifications.azurewebsites.net/api/notification"; // "http://localhost:7071/api/notification"

  public readonly UpdateSessionIdInLiveUrl =
    "Live/UpdateSessionIdInLive?trackName={0}&sessionId={1}";

  //Ticket
  public readonly CreateTicket = "Pricing/CreatePricing";
  public readonly getPriceDetails =
    "Pricing/GetPriceDetails?pricetype={0}&isAdmin={1}&eventId={2}";
  public readonly statusChangeprice =
    "Pricing/StatusChangePrice?id={0}&status={1}";
  public readonly updatePrice = "Pricing/UpdatePrice";

  //Coupon

  public readonly couponcreate = "Coupon/CouponCreate";
  public readonly getCoupan = "Coupon/GetAllCoupons?eventId={0}";
  public readonly statusChangeCoupon =
    "Coupon/StatusChangeCoupon?id={0}&status={1}";
  public readonly updateCoupon = "Coupon/CouponUpdate";
  public readonly createFaq = "Faq/CreateFaq";
  public readonly getFaqList = "Faq/FaqList?Type={0}&eventId={1}&isAdmin={2}";
  public readonly faqUpdate = "Faq/Updatefaq";

  //Attendess

  public readonly GetPaidAttendees =
    "Ticket/GetPaidAttendeesDetails?eventId={0}&isAdmin={1}";
  public readonly GetNotPaidAttendees =
    "Ticket/GetNotPaidAttendeesDetails?eventId={0}&isAdmin={1}";
  //PaymentGateway
  public readonly getPaymentStatus = "PhonePe/getPaymentStatus?";
  public readonly coupanValidate = "Coupon/Couponvalidate?CouponCode={0}";
  public readonly phonePeCreateBulkTicket = "Ticket/BulkCreatePhonePe";
  public readonly razoryPayCreateBulkTicket = "Ticket/BulkCreateRazoryPay";
  public readonly bulkTicketList = "Payment/BulkTicketPaymentList";
  public readonly paymentStatusCheck =
    "PhonePe/GetPaymentStatus?transactionId=";

  public getEventId(): string | null {
    return localStorage.getItem("eventId");
  }
}
